import React from 'react';
import BodyText from '../../Typography/BodyText/BodyText';
import Flex from '../../Flex/Flex';
import Gutter from '../../Gutter/Gutter';
import Icon from '../../Icon/Icon';
import Element, { CommonProps } from '../../Element/Element';

import styles from './AmountChip.module.scss';
import { CreateProps } from '../../../types/utils/CreateProps';

type AmountChipProps = CreateProps<
  {
    /** Chip text */
    text: string | number;
    /** Controls if initially disabled or not */
    disabled?: boolean;
    /** Function which fires on click on the whole chip  */
    onClick?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  },
  CommonProps<'button'>,
  'tagName' | 'boxShadow' | 'padding' | 'borderRadius' | 'onClick'
>;

const AmountChip: React.FunctionComponent<AmountChipProps> = ({
  text,
  disabled,
  onClick,
  ...props
}) => {
  const classNames = [styles.amountChip];

  disabled && classNames.push(styles.amountChip_disabled);

  return (
    <Element
      tagName="button"
      onClick={onClick}
      borderRadius={{ size: 'md' }}
      className={['amountChip-test', classNames]}
      padding={{ vertical: 'xs', horizontal: 'xs' }}
      {...props}
    >
      <Flex centered>
        <BodyText tagName="span" size="sm">
          {text}
        </BodyText>
        <Gutter size="xs" />
        <Icon name="close" size="xs" className={styles.amountChip_icon} />
      </Flex>
    </Element>
  );
};

export default AmountChip;
